import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b2973f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-footer footer" }
const _hoisted_2 = { class: "footer-wrap" }
const _hoisted_3 = { class: "page-buttons" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-line" }, null, -1))
const _hoisted_5 = {
  key: 0,
  class: "count"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ScrollButtons = _resolveComponent("ScrollButtons")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ScrollButtons, { scrollArea: _ctx.scrollArea }, null, 8, ["scrollArea"])
      ]),
      _hoisted_4,
      _createElementVNode("div", {
        class: _normalizeClass(["actions page-footer-actions", { 'no-margin': _ctx.pagination && _ctx.showPagination }])
      }, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true),
        (_ctx.pagination && _ctx.showTotalCount)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.translate("app_result", _ctx.pagination.total)), 1))
          : _createCommentVNode("", true)
      ], 2),
      (_ctx.pagination && _ctx.showPagination)
        ? (_openBlock(), _createBlock(_component_PaginationComponent, {
            key: 0,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:pagination', $event))),
            "hide-per-page": _ctx.hidePerPage
          }, null, 8, ["pagination", "hide-per-page"]))
        : _createCommentVNode("", true)
    ])
  ]))
}